<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__wrapper">
        <div class="footer__info">
          <router-link :to="{ name: 'home' }">
            <img src="@images/logo.png" alt="logo">
          </router-link>
          <p>LUNATRIX LTD, HE 466293 <br> Κάλυμνου, 1, "Q MERITO", Floor 4, 'Αγιος <br> Νικόλαος, Καμάρες 6037, Λάρνακα, Κύπρος <br> E-mail: <a href="mailto:info@lunatrixltd.com">info@lunatrixltd.com</a></p>
        </div>
        <div class="footer__columns">
          <div class="footer__column">
            <h6>Links</h6>
            <p @click="scrollTo('why', 'home')">Why us?</p>
            <p @click="scrollTo('hello', 'home')">Who We Are</p>
            <p @click="scrollTo('solutions', 'home')">Our Solutions</p>
            <p @click="scrollTo('contact', 'home')">Contact us</p>
          </div>
          <div class="footer__column">
            <h6>Support</h6>
            <router-link :to="{ name: 'terms' }"><p>Terms of Service</p></router-link>
            <router-link :to="{ name: 'policy' }"><p>Privacy Policy</p></router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="footer__bottom">
      <div class="container">
        <div class="footer__bottom-wrapper">
          2025 @LUNATRIX LTD. All Rights Reserved.
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import {scroll} from "@/core/helpers/scrollTo.js";
import {useRoute, useRouter} from "vue-router";

const router = useRouter()
const route = useRoute()

const scrollTo = (id, routeName) => {
  if (route.name === routeName) {
    scroll(id);
  } else {
    router.push({
      name: 'home'
    }).then(scroll(id));
  }
}
</script>

<style lang="scss" scoped>
.footer {
  box-shadow: 0 1px 0 0 #E1E3E5 inset;

  &__wrapper {
    padding-block: 75px 50px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  &__info {
    & p {
      margin-top: 20px;
      opacity: 0.6;

      color: #272343;
      font-size: 14px;
      font-weight: 400;
    }
  }

  &__columns {
    display: flex;
    align-items: flex-start;
    gap: 100px
  }

  &__column {
    display: flex;
    flex-direction: column;
    gap: 12px;

    & h6 {
      margin-bottom: 8px;
      color: #9A9CAA;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.84px;
      text-transform: uppercase;
    }

    & p {
      cursor: pointer;
      color: #272343;
      font-size: 14px;
      font-weight: 400;
      transition: 0.2s;

      @include hover {
        color: #151325;
      }
    }
  }

  &__bottom {
    padding-block: 24px;
    box-shadow: 0 1px 0 0 #E1E3E5 inset;

    &-wrapper {
      text-align: center;
      color: #9A9CAA;
      font-size: 14px;
      font-weight: 400;
    }
  }
}

a {
  @include hover {
    color: #000000;
  }
}

@media (max-width: 800px) {
  .footer {
    &__wrapper {
      flex-direction: column;
      align-items: center;
      gap: 50px;
    }
  }
}
</style>